module.exports = __webpack_public_path__ + "static/media/YM01_2.252f8c49.jpg";